export function cleanupHtmlTags(str: string) {
  return str.replace(/<[^>]*>/g, '').replace(/&[^;]+;/g, '');
}
